// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import VueRouter from 'vue-router';
import ElementUI from 'element-ui';
// import Viewer from 'v-viewer' //图片查看器
import 'viewerjs/dist/viewer.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css'
import App from '@/App'
import VModal from 'vue-js-modal'
import echarts from 'echarts'
import router from './router'
import store from './store/index'; //引入store
// import axios from 'axios'
import { sync } from 'vuex-router-sync'

// import Print from 'vue-print-nb'
// import './assets/js/validate.js' //引入vee-validate验证组件
import 'view-design/dist/styles/iview.css';
import BaiduMap from 'vue-baidu-map'

import 'babel-polyfill';
import Es6Promise from 'es6-promise'
Es6Promise.polyfill();

// Vue.prototype.$ajax= axios;
Vue.prototype.$echarts = echarts;

// Vue.use(Viewer);

// Viewer.setDefaults({
//     Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
// });

// axios.defaults.baseURL = '/api';
// axios.defaults.baseURL = '/';

// axios.interceptors.request.use(config => {
//     config.headers = {
//     'Content-Type': 'application/json; charset=UTF-8'
//     }
//     return config;
// });

Vue.config.productionTip = false;

// Vue.use(Print);
Vue.use(ElementUI);
Vue.use(VModal,{ dialog: true })
Vue.use(BaiduMap, {
    ak: '70uZmQ1dPu8B34uk3PYMg50R'
  })
// 使store支持路由
sync(store, router)
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //挂载store
    components: {App},
    template: '<App/>'
})






// WEBPACK FOOTER //
// ./src/main.js